









































import { Vue, Component } from 'vue-property-decorator';
import SpaceFileNode from '../components/space-file-node.vue';
import * as api from '@/api';

/**
 * rg问题归档
 *
 * @author liyuyao
 * @date 11/07/2020
 */
@Component({
    components: {
        SpaceFileNode
    }
})
export default class SpaceDetailFile extends Vue {
    openFile: boolean = false;

    // data: any = [{
    //     title: '唐诗',
    //     id: '0',
    // }, {
    //     title: '宋词',
    //     id: '1',
    // }, {
    //     title: '绝句',
    //     id: '2',
    // }];

    data: any = [];

    createDialogVisble: boolean = false;
    editDialogVisble: boolean = false;

    async mounted() {
        this.getSpaceFileSetting();
    }
    async getSpaceFileSetting() {
        const res = await api.spaceApi.getSpaceFileSetting(this.spaceId);
        if (res && res.code === 200) {
            this.openFile = res.data.active;
            const root = res.data.rootNode;
            if (root) this.data = [root];
        }
    }
    async openFileChange(open) {
        const res = await api.spaceApi.spaceFileActive(this.spaceId, open);
        if (res && res.code === 200) {
            this.$mtd.message.success('操作成功');
            const root = res.data.rootNode;
            if (root) this.data = [root];
        }
    }

    async loadData(node, callback) {
        const result = await this.getNodesByParent(node.data.id);
        callback(result);
    }
    async getNodesByParent(parentId: number) {
        const res = await api.spaceApi.getNodesByParent(parentId);
        return res.data.items || [];
    }
    addNode(node, data) {
        const { id } = node.data;
        this.$mtd
            .confirm({
                title: '添加子分类',
                message: '分类名称：<input id="space-file-add" class="mtd-input" style="width: 280px" />',
                dangerouslyUseHTMLString: true,
                onOk: async () => {
                    const inputElement = document.getElementById('space-file-add') as HTMLInputElement;
                    const nodeText = inputElement.value;
                    if (nodeText.length) {
                        try {
                            const res = await api.spaceApi.addNodes({
                                parentId: id,
                                name: nodeText
                            });
                            if (res && res.code === 200) {
                                const newData = res.data;
                                const newChildren = data.children ? data.children.concat(newData) : newData;
                                // data.children = newChildren;
                                this.$nextTick(() => {
                                    this.$set(data, 'children', newChildren);
                                    this.$set(data, 'leaf', false);
                                });
                                // this.$set(data, 'children', newChildren);
                                this.$mtd.message.success('操作成功');
                            }
                        } catch (e) {
                            console.log('e', e);
                        }
                    }
                }
            })
            .catch(e => e);
    }
    editNode(node, data) {
        const { id } = node.data;
        this.$mtd
            .confirm({
                title: '编辑分类名称',
                message: `分类名称：<input id="space-file-edit" class="mtd-input" style="width: 280px" value="${node.data.name}" />`,
                dangerouslyUseHTMLString: true,
                onOk: async () => {
                    const inputElement = document.getElementById('space-file-edit') as HTMLInputElement;
                    const nodeText = inputElement.value;
                    if (nodeText.length && nodeText.length < 200) {
                        const res = await api.spaceApi.updateNodes({
                            id: id,
                            name: nodeText
                        });
                        if (res && res.code === 200) {
                            this.$nextTick(() => {
                                this.$set(data, 'name', nodeText);
                            });
                            this.$mtd.message.success('操作成功');
                        }
                    } else {
                        this.$mtd.message.error('分类名称限200字');
                    }
                }
            })
            .catch(e => e);
    }
    useStatusChange(node) {
        const { data } = node;
        this.$mtd
            .confirm({
                message: `${data.inUse ? '停用' : '启用'}此分类吗？`,
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: data.inUse ? '停用' : '启用',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    const res = await api.spaceApi.updateNodes({
                        id: data.id,
                        inUse: !data.inUse
                    });
                    if (res && res.code === 200) {
                        this.$mtd.message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.$set(data, 'inUse', !data.inUse);
                    }
                }
            })
            .catch(e => e);
    }
    get spaceId() {
        return parseInt(this.$route.params.id, 10);
    }
}
